import { CardCreationForm } from "@/components/cards/CardRoulette";
import { useCardCreation } from "@/hooks/useCardCreation";
import { useNavigate } from "react-router-dom";

export function CreateCard() {
  const navigate = useNavigate();
  const { state, actions } = useCardCreation((path: string) => navigate(path));

  return <CardCreationForm state={state} actions={actions} />;
} 